import { Gallery } from "../components/Gallery";

export function GalleryPage() {
  return <Gallery />;
}
